; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/ContentSearch/FacetContainer',["jquery", "eventManager", "score_bootstrap/Utils/UrlHelper", "score_bootstrap/Components/ContentSearch/FacetContainer",
        "score_bootstrap/Models/Search/FacetPanel", "MM/Components/ContentSearch/FacetSingleChoicePanel", "MM/Components/ContentSearch/FacetMultipleChoicePanel",
        "MM/Components/ContentSearch/FacetCascadedPanel", "MM/Components/ContentSearch/FacetTogglePanel", "MM/Components/ContentSearch/FacetHierarchyMultipleChoicePanel"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require("score_bootstrap/Utils/UrlHelper"),
        require("score_bootstrap/Components/ContentSearch/FacetContainer"), require("score_bootstrap/Models/Search/FacetPanel"), require("MM/Components/ContentSearch/FacetSingleChoicePanel"),
        require("MM/Components/ContentSearch/FacetMultipleChoicePanel"), require("MM/Components/ContentSearch/FacetCascadedPanel"), require("MM/Components/ContentSearch/FacetTogglePanel"),
        require("MM/Components/ContentSearch/FacetHierarchyMultipleChoicePanel")) :
    console && console.error('SearchResults does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, urlHelper, ScoreFacetContainer, FacetPanel, FacetSingleChoicePanel, FacetMultipleChoicePanel, FacetCascadedPanel, FacetTogglePanel, FacetHierarchyPanel) {

    function FacetContainer(scope, uniqueId, inputChangeEvents) {
        //if there is data-unique-id-override attribute assigned we override facet container uniqueId value with a new value from attribute
        //this is to unify uniqueId over different pages, so we can assign facet value from one page to a facet on another page
        if (scope.hasAttribute('data-unique-id-override')) {
            uniqueId = scope.getAttribute('data-unique-id-override');
        }

        // ScoreFacetContainer
        Object.defineProperty(this, 'uniqueId', { enumerable: !1, value: uniqueId });
        // initialize facet earlier then it is done in the ScoreFacetContainer logic. 
        // And when ScoreFacetContainer will try to do the same, it'll get instances of our custom Facets instead of FacetPanel. 
        // Because FacetPanel will load an instance of a facet from data('facet')
        this.initFacetPanels(scope);
        this.fixAccessibility(scope);
        // call inherited
        ScoreFacetContainer.call(this, scope, uniqueId, inputChangeEvents);

        // setup delay to support batch update
        this.selectedFacets.extend({deferred: true});
        
    }

    // inherit prototype methods. even if there is no methods for now, at some point we will make them
    FacetContainer.prototype = Object.create(ScoreFacetContainer.prototype);

    FacetContainer.prototype.fixAccessibility = function fixAccessibility(scope){
        var clearAllElement = scope.querySelector('.clear-facets');          
            clearAllElement.setAttribute('tabindex', '0');        
    }

    FacetContainer.prototype.initFacetPanels = function initFacetPanels(scope) {
        // querySelectorAll returns a NodeList which actually doesn't have the map() method, but it has an iterator, so we still can use map from the Array prototype
        return Array.prototype.map.call(scope.querySelectorAll('.score-facet-panel'), function (el) {

            var elClassNames = (' ' + el.className + ' ');
            if (~elClassNames.indexOf(' score-facet-dropdown-single-choice ')) {
                return new FacetSingleChoicePanel(el, this.getPreselected(), this.uniqueId + "facet");
            }

            if (~elClassNames.indexOf(' score-facet-dropdown-office-choice ')) {
                return new FacetSingleChoicePanel(el, this.getPreselected(), this.uniqueId + "facet");
            }

            if (~elClassNames.indexOf(' score-facet-dropdown-multiple-choice ')) {
                return new FacetMultipleChoicePanel(el, this.getPreselected(), this.uniqueId + 'facet');
            }

            if (~elClassNames.indexOf(' score-facet-dropdown-hrchy-choice ')) {
                return new FacetHierarchyPanel(el, this.getPreselected(), this.uniqueId + 'facet');
            }

            if (~elClassNames.indexOf(' score-facet-dropdown-cascaded ')) {
                return new FacetCascadedPanel(el, this.getPreselected(), this.uniqueId + 'facet');
            }

            if (~elClassNames.indexOf(' score-facet-toggle ')) {
                return new FacetTogglePanel(el, this.getPreselected(), this.uniqueId + "facet");
            }

            return new FacetPanel(el, this.getPreselected());
        }.bind(this));
    }

    FacetContainer.prototype.getPreselected = function getPreselected() {
        var preselected = urlHelper.getHashValue(this.uniqueId + "facet");
        if (!preselected) {
            preselected = urlHelper.getHashValue("facet");
            if (preselected) {
                urlHelper.setHashValue(window.location, '/' + this.uniqueId + 'facet', preselected.length ? preselected : null);
            }
           }       
        preselected = preselected ? preselected.split(",") : [];
        return preselected.reduce(this.processPreselected, {});
    }

    FacetContainer.prototype.processPreselected = function processPreselected(result, current) {
        var i = current.indexOf(":");
        var facetName = current.substr(0, i);
        var preselectedFacetValues = current.substr(i + 1).split("|");

        if (result.hasOwnProperty(facetName) === false) {
            result[facetName] = [];
        }

        result[facetName] = result[facetName].concat(preselectedFacetValues);
        return result;
    }


    FacetContainer.init = function init(args) {
        return args.IsEditorEditing === true ? null : new FacetContainer(
            args.scope,
            args.UniqueId,
            args.InputChangeMessagesTransmitting || []
        );
    };

    return FacetContainer;
}));
